<template>
  <div class="text-dark section section--border-top pdf_results">
    <div class="container">
      <div class="container__inner">
        <div class="items-center pb-1 section-title lg:pb-2">
          <h2 class="text-base uppercase lg:text-lg">
            {{ quizStore.quiz.title }}
          </h2>
          <h3 class="text-base lg:text-lg">
            {{ quizStore.user.display_name }} (
            {{ quizStore.user.user_email }} )
            <span class="text-sm">
              - {{ d(Date.parse(quizStore.quiz.created_at), "long") }}</span
            >
          </h3>

          <h2 class="mt-2 text-lg lg:text-xl">
            Votre score : {{ quizStore.getScore() }} %
          </h2>
        </div>

        <div class="quiz-slider">
          <div class="flex flex-wrap justify-between">
            <div class="w-full">
              <div
                class="quiz-result-item swiper-slide"
                v-for="(question, idx) in answeredQuestions"
              >
                <div class="flex flex-wrap py-1">
                  <div class="pt-0.5 pr-1.5 leading-normal flex-shrink-0">
                    {{ idx + 1 }}/{{ answeredQuestions.length }}
                  </div>
                  <p class="flex-1 p-0 m-0 text-2xl leading-normal">
                    {{ question.title }}
                  </p>
                </div>

                <component
                  :is="quizResultsTypes[question.type]"
                  :question="question"
                  :answer="
                    quizStore.answers.find(
                      (answer) => parseInt(answer.question_id) == question.id
                    )
                  "
                />
              </div>
            </div>
          </div>
          <!-- .flex -->
        </div>
        <!-- .quiz-slider -->
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { useQuizStore } from "@/stores/quiz";
import CircleIcon from "./icons/CircleIcon.vue";
import CaretIcon from "./icons/CaretIcon.vue";

import QuizResultsQCU from "./QuizResultsQCM.vue";
import QuizResultsQCM from "./QuizResultsQCM.vue";
import QuizResultsQPO from "./QuizResultsQPO.vue";
import QuizResultsQPA from "./QuizResultsQPA.vue";
import QuizResultsQRS from "./QuizResultsQRS.vue";

const quizResultsTypes = {
  QCU: QuizResultsQCU,
  QCM: QuizResultsQCM,
  QPO: QuizResultsQPO,
  QPA: QuizResultsQPA,
  QRS: QuizResultsQRS,
};

const { d } = useI18n();

const quizStore = useQuizStore();
const questions = Object.values(quizStore.quiz.segments).flatMap(
  (segment) => segment.questions
);
const answeredQuestions = questions.filter((question) =>
  quizStore.answers.find(
    (answer) => parseInt(answer.question_id) == question.id
  )
);
</script>
